export const DEFAULT_LOGO_URL =
  "https://mcdfkrkgkwrddtwetfww.supabase.co/storage/v1/object/public/paystreem-uploads/site-logo.png";
export const DEFAULT_FAVICON_URL =
  "https://mcdfkrkgkwrddtwetfww.supabase.co/storage/v1/object/public/paystreem-uploads/site-favicon.png";
export const DEFAULT_PROFILE_IMAGE_URL =
  "https://mcdfkrkgkwrddtwetfww.supabase.co/storage/v1/object/public/paystreem-uploads/default-profile-image.png";
export const DEFAULT_FOOTER_LOGO_URL =
  "https://mcdfkrkgkwrddtwetfww.supabase.co/storage/v1/object/public/paystreem-uploads/footer-logo.png";
export const DEFAULT_OG_IMAGE_URL =
  "https://mcdfkrkgkwrddtwetfww.supabase.co/storage/v1/object/public/paystreem-uploads/og-image.png";

export const BRANDING_STORAGE_BUCKET = "paystreem-uploads";
export const LOGO_FILENAME = "site-logo.png";
export const FAVICON_FILENAME = "site-favicon.png";
export const DEFAULT_PROFILE_IMAGE_FILENAME = "default-profile-image.png";
export const FOOTER_LOGO_FILENAME = "footer-logo.png";
export const OG_IMAGE_FILENAME = "og-image.png";

export const BRANDING_QUERY_KEY = "branding-assets";

export const UPLOAD_CONSTRAINTS = {
  maxSizeMB: 2,
  acceptedTypes: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
  logoAspectRatio: 1, // Square — rendered as an icon badge in the navbar/sidebar
  faviconAspectRatio: 1, // Square for favicon
  defaultProfileImageAspectRatio: 1, // Square for profile image
  footerLogoAspectRatio: 16 / 9, // Rectangular for footer logo
  ogImageAspectRatio: 1200 / 630, // ~1.91:1 for Open Graph
  logoOutputWidth: 512,
  logoOutputHeight: 512,
  faviconOutputSize: 512,
  defaultProfileImageOutputSize: 512,
  footerLogoOutputWidth: 512,
  footerLogoOutputHeight: 288,
  ogImageOutputWidth: 1200,
  ogImageOutputHeight: 630,
} as const;
